import { useAuth0 } from '@auth0/auth0-react';
import { FormControl, MenuItem, Select, InputLabel, Autocomplete, TextField } from '@mui/material';
import { getAllCentersMaster, getAllCenterTypesMaster } from '../../api/carteleriaApi';
import { useQuery } from '@tanstack/react-query';
import { ordenarPorPropiedad } from '../../helpers/sortFunctions';
import { FaArrowRight } from 'react-icons/fa';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import { Tooltip } from 'react-tooltip';

const FiltersArtes = ({
  valueCenterType,
  setValueCenterType,
  valueCenter,
  setValueCenter,
  valueStatus,
  setValueStatus,

  orderBy,
  setOrderBy,
  favouriteMasterCluster,
  setFavouriteMasterCluster,

  issuesFilter,
  setIssuesFilter,

  withValidation,
  withOrder,

  catalogSize,
}) => {
  const { getAccessTokenSilently } = useAuth0();

  const { data: centers } = useQuery(['centers-master', valueCenterType], async () => {
    const token = await getAccessTokenSilently();
    return await getAllCentersMaster(token, valueCenterType);
  });

  const { data: centerTypes, isFetching: fetchingCenterTypes } = useQuery(['center-types-master'], async () => {
    const token = await getAccessTokenSilently();
    return await getAllCenterTypesMaster(token);
  });

  return (
    <div className="ai-c df-jcsb w-100">
      {/* Filtro para Status */}
      <FormControl size="small" style={{ width: catalogSize ? '13%' : '20%' }}>
        <InputLabel id="filter-status-master-label">Estado</InputLabel>
        <Select
          labelId="filter-status-master-label"
          id="filter-status-master"
          value={valueStatus}
          label="Estado"
          onChange={(e) => setValueStatus(e.target.value)}
        >
          <MenuItem value={'all'}>Todos</MenuItem>
          <MenuItem value={'active'}>Activos</MenuItem>
          <MenuItem value={'notActive'}>Inactivos</MenuItem>
        </Select>
      </FormControl>

      {/* FILTRO PARA CENTER TYPE */}
      <FormControl size="small" style={{ width: catalogSize ? '13%' : '20%' }}>
        <InputLabel id="filter-centertype-master-label">Cluster</InputLabel>
        <Select
          labelId="filter-centertype-master-label"
          id="filter-centertype-master"
          value={valueCenterType}
          label="Cluster"
          onChange={(e) => setValueCenterType(e.target.value)}
        >
          <MenuItem value="all">Todos</MenuItem>
          {!fetchingCenterTypes &&
            centerTypes?.data?.sort(ordenarPorPropiedad('index')).map((centerType) => (
              <MenuItem key={centerType._id} value={centerType._id}>
                {centerType.type}
              </MenuItem>
            ))}
        </Select>
      </FormControl>

      <Autocomplete
        size="small"
        id="filter-center-master"
        style={{ width: catalogSize ? '13%' : '20%' }}
        options={centers?.data || []}
        getOptionLabel={(option) => `${option.code} - ${option?.name || option?.calle}`}
        value={valueCenter}
        onChange={(event, newValue) => {
          setValueCenter(newValue);
        }}
        noOptionsText="No existen centros con ese nombre o código"
        renderInput={(params) => (
          <TextField
            {...params}
            // variant="standard"
            label="Centro"
            sx={{ '& label.Mui-focused': { color: 'black' } }}
            placeholder="Ej: ES0001, Utebo.. "
          />
        )}
      />

      {withValidation && (
        <FormControl size="small" style={{ width: catalogSize ? '13%' : '20%' }}>
          <InputLabel id="filter-centertype-master-label">Validación</InputLabel>
          <Select
            labelId="filter-centertype-master-label"
            id="filter-centertype-master"
            value={issuesFilter}
            label="Cluster"
            onChange={(e) => setIssuesFilter(e.target.value)}
          >
            <MenuItem value="all">Todos</MenuItem>
            <MenuItem value="with-warnings">Con advertencias</MenuItem>
            <MenuItem value="with-errors">Con errores</MenuItem>
          </Select>
        </FormControl>
      )}
      <div style={{ width: '10%' }}></div>

      {withOrder && (
        <>
          {/* // ahora vamos a añadir otro formControl con un select para añadir un filtro de validación: */}
          <div style={{ position: 'relative', width: catalogSize ? '13%' : '20%' }}>
            <FormControl size="small" fullWidth>
              <InputLabel id="filter-order-master-label">Orden</InputLabel>
              <Select
                labelId="filter-order-master-label"
                id="filter-order-master"
                value={orderBy}
                label="Orden"
                onChange={(e) => setOrderBy(e.target.value)}
              >
                <MenuItem value="favorites">Por favoritos...</MenuItem>
                <MenuItem value="createdAt">Por creación</MenuItem>
                <MenuItem value="alphabetical">Por orden alfabético</MenuItem>
              </Select>
            </FormControl>

            {orderBy === 'favorites' && favouriteMasterCluster === 'none' && (
              <>
                <HelpOutlineIcon
                  className="favorites-tooltip-order"
                  style={{
                    position: 'absolute',
                    top: -6,
                    right: -6,
                    fontSize: 18,
                    color: '#f57c00',
                    cursor: 'help',
                    zIndex: 2,
                  }}
                />
                <Tooltip
                  anchorSelect=".favorites-tooltip-order"
                  place="top"
                  delayShow={250}
                  positionStrategy="fixed"
                  style={{
                    padding: '2px 10px',
                    borderRadius: 6,
                    fontSize: 12,
                    zIndex: 9999,
                    backgroundColor: '#f58b1f',
                  }}
                >
                  Selecciona un cluster para ordenar por favoritos
                </Tooltip>
              </>
            )}
          </div>

          {/* // ahora sacar todos los clusters , pero si hay uno seleccionado en cluster, poner ese  */}

          {orderBy === 'favorites' ? (
            <div style={{ flex: '0 0 auto', margin: '0px' }}>
              <FaArrowRight size={14} />
            </div>
          ) : (
            <div style={{ flex: '0 0 auto', margin: '0px' }}></div>
          )}

          {orderBy === 'favorites' ? (
            <FormControl size="small" style={{ width: '13%' }}>
              <InputLabel id="filter-centertype-master-label">Cluster</InputLabel>
              <Select
                labelId="filter-centertype-master-label"
                id="filter-centertype-master"
                value={favouriteMasterCluster}
                label="Cluster"
                onChange={(e) => setFavouriteMasterCluster(e.target.value)}
              >
                <MenuItem value="none">Ninguno</MenuItem>
                {!fetchingCenterTypes &&
                  valueCenterType === 'all' &&
                  centerTypes?.data?.sort(ordenarPorPropiedad('index')).map((centerType) => (
                    <MenuItem key={centerType._id} value={centerType._id}>
                      {centerType.type}
                    </MenuItem>
                  ))}
                {!fetchingCenterTypes &&
                  valueCenterType !== 'all' &&
                  centerTypes?.data
                    ?.filter((centerType) => centerType._id === valueCenterType)
                    .sort(ordenarPorPropiedad('index'))
                    .map((centerType) => (
                      <MenuItem key={centerType._id} value={centerType._id}>
                        {centerType.type}
                      </MenuItem>
                    ))}
              </Select>
            </FormControl>
          ) : (
            <FormControl size="small" style={{ width: '15%' }}></FormControl>
          )}
        </>
      )}
    </div>
  );
};

export default FiltersArtes;
